import * as React from "react";
import classnames from "classnames";
import Link from "../../Link/Link/Link.js";
/* empty css         */
const TabLink = React.forwardRef(
  ({ isActive, className, ...rest }, ref) => /* @__PURE__ */ React.createElement(Link, { ...rest, ref, className: classnames("tab", className, { _is_active: isActive }) })
);
TabLink.displayName = "TabLink";
export {
  TabLink as default
};
//# sourceMappingURL=TabLink.js.map
